/* MUTATION TYPES
-------------------------------------------------------------- */
export const SET_PARTNERS = 'SET_PARTNERS';
export const SET_PARTNER = 'SET_PARTNER';
export const SET_PARTNER_PERSONTYPE = 'SET_PARTNER_PERSONTYPE';
